import {
    Box,
    Group,
    Image,
    Paper,
    Text,
} from '@mantine/core';
import { IconContext } from 'react-icons';
import { AiOutlineExport } from 'react-icons/ai';
import { DashletType } from '../types.ts';
import { getApplicationLogo } from '../../../utils/getApplicationLogo.ts';
import classes from './Dashlet.module.css';

export const Dashlet = ({ item }: { item: DashletType }) => {
    const localLogo = getApplicationLogo(item.app);

    return (
        <Paper
            component="a"
            href={item.location}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${item.app}`}
            className={classes.card}
            withBorder
            radius="md"
            p="lg"
            shadow="sm"
        >
            <Box
                style={{
                    position: 'absolute',
                    top: 12,
                    right: 12,
                    opacity: 0.35,
                }}
            >
                <AiOutlineExport size={14} />
            </Box>

            <Group gap="lg" wrap="nowrap" align="center">
                <Box
                    style={{
                        flexShrink: 0,
                        width: 80,
                        height: 40,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                    }}
                >
                    {localLogo ? (
                        <Image
                            src={localLogo}
                            alt={item.app}
                            mah={40}
                            maw={80}
                            w="auto"
                            h="auto"
                            fit="contain"
                        />
                    ) : (
                        <IconContext.Provider value={{ size: '36' }}>
                            <Box aria-hidden="true">{item.icon}</Box>
                        </IconContext.Provider>
                    )}
                </Box>

                <Box style={{ minWidth: 0 }}>
                    <Text
                        size="sm"
                        fw={700}
                        tt="uppercase"
                        truncate
                        lh={1.3}
                    >
                        {item.app}
                    </Text>
                    {item.description && (
                        <Text size="xs" c="dimmed" lineClamp={2} lh={1.4} mt={2}>
                            {item.description}
                        </Text>
                    )}
                </Box>
            </Group>
        </Paper>
    );
};
